import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=5fbc5276&scoped=true&"
import script from "./Certificate.vue?vue&type=script&lang=js&"
export * from "./Certificate.vue?vue&type=script&lang=js&"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=5fbc5276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc5276",
  null
  
)

export default component.exports